import { ConfigData, ConfigFieldName, DEFAULT_CONFIG_DATA } from '../../types/config'
import type { ConfigSchema } from '../../types/gotypes'

/**
 * Returns a copy of the form data with every bool field as a real boolean.
 * A merged-config source carries a bool as the text "true" or "false", and a
 * form that loaded before the schema keeps it that way; the server then
 * refuses the whole save ("cannot unmarshal string into ... of type bool").
 * Without a schema, a field counts as bool when its default value is one.
 * Both the Save button and auto-save send what this returns.
 */
export const normalizeConfigForSave = (data: ConfigData, schema: ConfigSchema | null): ConfigData => {
  const out: ConfigData = { ...data }
  const defaults = DEFAULT_CONFIG_DATA as unknown as Record<string, unknown>
  for (const fieldName of Object.keys(out) as ConfigFieldName[]) {
    const def = schema?.fields?.[fieldName]
    const isBool = def ? def.type === 'bool' : typeof defaults[fieldName] === 'boolean'
    if (!isBool) continue
    const value = out[fieldName] as unknown
    ;(out as unknown as Record<string, unknown>)[fieldName] = value === true || value === 'true'
  }
  return out
}
